module.exports = __webpack_public_path__ + "img/tag.eedec029.svg";